'use strict';

module.exports = {
    openAccordionItem: function () {
        $('body').on('click', '.pd-section .accordian-item .item-header, .refinement-bar .item-header', function (e) {
            e.stopImmediatePropagation();
            let $accordionItem = $(this).parents('.accordian-item');
            let wasActive = $accordionItem.hasClass('active');

            $accordionItem.toggleClass('active');
            let expandOneAtTime = $(this).parents('.pd-section').data('expand-one-at-time');
            if (expandOneAtTime) {
                $(this).parents('.pd-section').find('.accordian-item').not($accordionItem)
                    .removeClass('active');
            }

            // If accordion is being expanded (not collapsed) and is near viewport bottom
            if (!wasActive) {
                let viewportHeight = $(window).height();
                let scrollTop = $(window).scrollTop();
                let elementTop = $accordionItem.offset().top;
                let elementHeight = $accordionItem.outerHeight();
                let elementBottom = elementTop + elementHeight;
                let viewportBottom = scrollTop + viewportHeight;

                // Check if element is in the lower half of the viewport or extends beyond it
                // let elementMiddle = elementTop + (elementHeight / 2);
                // let viewportMiddle = scrollTop + (viewportHeight / 2);
                // elementMiddle > viewportMiddle || elementBottom > viewportBottom

                if (elementBottom > viewportBottom) {
                    // Scroll the question to the top with some offset for better visibility
                    let scrollOffset = 100; // pixels from top
                    $('html, body').animate({
                        scrollTop: elementTop - scrollOffset
                    }, 400);
                }
            }
        });

        // Check if URL has a hash targeting an accordion item
        if (window.location.hash) {
            let targetId = window.location.hash;
            let $targetItem = $(targetId);

            if ($targetItem.length && $targetItem.hasClass('accordian-item')) {
                // Open the targeted accordion item
                $targetItem.addClass('active');

                // If expandOneAtTime is enabled, close other items
                let $container = $targetItem.parents('.pd-section');
                let expandOneAtTime = $container.data('expand-one-at-time');
                if (expandOneAtTime) {
                    $container.find('.accordian-item').not($targetItem).removeClass('active');
                }

                // Scroll to the targeted item after a short delay to ensure content is loaded
                setTimeout(function () {
                    let scrollOffset = 100; // pixels from top
                    $('html, body').animate({
                        scrollTop: $targetItem.offset().top - scrollOffset
                    }, 400);
                }, 100);
            }
        }
    }
};
